import { useState } from 'react';
import { MBHover } from '@shared/components/hover';
import { MBChatAttachment } from '@shared/scenes/chat/thread/containers/attachmentWithUploadProgress';
import { getAnchorName, grid } from '@shared/styles';

import { API } from '@shared/types/api';
import { Styles } from '../styles';
import { MessageHoverContent } from './MessageHoverContent';

interface MBMessageBubbleAttachmentProps {
  message: API.ChatMessageFragment;
  align: 'left' | 'right';
  attachment: API.ChatAttachmentFragment;
  channelSlug: string;
  isSent: boolean;
  onLongPress?: () => void;
  onClick?: (attachment: API.ChatAttachmentFragment) => void;
  isFirstMessageInGroup: boolean;
}

export function MBMessageBubbleAttachment({
  attachment,
  message,
  channelSlug,
  align,
  isSent,
  onLongPress,
  onClick,
  isFirstMessageInGroup,
}: MBMessageBubbleAttachmentProps) {
  const [isHovering, setIsHovering] = useState(false);
  const [dims, setDims] = useState({ width: 0, height: 0 });
  const showHoverContentWhenRight = isHovering;
  const showHoverContentWhenLeft = isHovering || !message.meta.reactions.length;
  const anchorName = getAnchorName('reaction-button-attachment', message.id, attachment.fileKey);

  return (
    <MBHover
      style={[
        align === 'left' && Styles.rowAlignLeft,
        align === 'right' && Styles.rowAlignRight,
        !isFirstMessageInGroup && { paddingTop: grid(1) },
      ]}
      onHoverStart={() => setIsHovering(true)}
      onHoverEnd={() => setIsHovering(false)}
      onSize={newDims => setDims(newDims)}
    >
      <>
        <MBChatAttachment
          attachment={attachment}
          style={Styles.bubbleMaxWidth}
          isSending={!isSent}
          onLongPress={onLongPress}
          onClick={onClick}
          containerWidth={dims.width}
          containerHeight={dims.height}
        />
        <MessageHoverContent
          showContent={align === 'right' ? showHoverContentWhenRight : showHoverContentWhenLeft}
          align={align}
          message={message}
          channelSlug={channelSlug}
          includeEdit={false}
          reactionPickerAnchorName={anchorName}
        />
      </>
    </MBHover>
  );
}
